$(window).on("load scroll resize", function () {
  var st = $(window).scrollTop();
  var wh = $(window).height();
  var currentId = null;

  $('#main_content .menu_content').each(function () {
    var tg = $(this).offset().top;
    var id = $(this).attr('id');

    if (st > tg - (wh / 4)) {
      currentId = id;
    }
  });

  // Update active state only if a match is found
  $(".k_header_nav .navbar .menu-item li a").removeClass("is-active");
  if (currentId) {
    $(".k_header_nav .navbar .menu-item li a[href*='" + currentId + "']").addClass("is-active");
  }
});
 
 
function scroll_fadein(){
	$('.js-border, .js-fadeIn,  .js-ttl-bg, .js-bottom-to-top').each(function(){
	    var elemPos = $(this).offset().top;
	    var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (window.innerWidth >= 992) { 
        if (scroll > elemPos - windowHeight + 250){
	        $(this).addClass('is-active');
        }
      } else {
        if (scroll > elemPos - windowHeight + 90){
	        $(this).addClass('is-active');
        }
      }
  });
}
$(document).ready(function() {
	$(window).scroll(function (){
	    scroll_fadein();
  });
  scroll_fadein();
});
 /*
$(window).on('scroll', function(){
    if($(window).scrollTop() > 100){
        $('.k_header_nav').addClass('show_header');
    }else{ 
        $('.k_header_nav').removeClass('show_header');
    }
}); 
*/
$(document).ready(function () {
  function handleVideoPlayback() {
    var scrollTop = $(window).scrollTop();
    var viewportHeight = $(window).height();

    $('video').each(function () {
      var $video = $(this);
      var videoTop = $video.offset().top;

      if ((scrollTop + viewportHeight + 200) > videoTop) {
        if ($video[0].paused) {
          $video[0].play().catch(() => {});
        }
      }  
    });
  }

// $(window).on('scroll resize', handleVideoPlayback); 

  $(document).on('click','.menu_close_icon, .navbar a',function(){
    $('.k_header_nav').removeClass('active');  
  });
  $(document).on('click','.menu_open_icon',function(){
    $('.k_header_nav').addClass('active');  
  });
  
  $('.menu_close_icon, .navbar a').click(function(){ 
    $('.k_header_nav').removeClass('active'); 
    console.log('removed'); 
  });
    $(document).on('input change', '.f_quantity', function() {
        var quantityValue = $(this).val();

        // Find the closest .product_main_section parent
        var $parentSection = $(this).closest('.product_main_section');

        // Find all .p_form elements inside and update the hidden input
        $parentSection.find('.p_form input[type="hidden"][name="quantity"]').val(quantityValue);
    });
   document.querySelectorAll('.review_slide').forEach((swiperEl, index) => {
     
  // Create navigation buttons
  const prevBtn = document.createElement('div');
  prevBtn.className = `swiper-button-prev swiper-button-prev-${index}`;

  const nextBtn = document.createElement('div');
  nextBtn.className = `swiper-button-next swiper-button-next-${index}`;

  // Append buttons to swiper parent
  swiperEl.parentElement.appendChild(prevBtn);
  swiperEl.parentElement.appendChild(nextBtn);

       
    const swiperInstance = new Swiper(swiperEl, {
          slidesPerView: 3,
          grid: {
            rows: 1,
            fill: "row",
          },
          loop: true,
          allowTouchMove: true,
          speed: 500,   
          navigation: {
            nextEl: `.swiper-button-next-${index}`,
            prevEl: `.swiper-button-prev-${index}`,
          },
          breakpoints: {
            0: {
              slidesPerView: 1,
              grid: {
                rows: 1,
                fill: "row",
              },
            },
            767: {
              slidesPerView: 1,
              grid: {
                rows: 1,
                fill: "row",
              },
            },
            991: {
              slidesPerView: 3,
              grid: {
                rows: 1,
                fill: "row",
              },
            },
          } 
        });
     
   });



  
    document.querySelectorAll('.marquee-swiper').forEach((swiperEl, index) => {
          function markSecondRowSlides(swiper) {
      // Clear previous classes
      swiper.slides.forEach((slide) => {
        slide.classList.remove("second-row");
      });
  
      const slidesPerView = swiper.params.slidesPerView;
      const rows = swiper.params.grid?.rows || 1;
  
      swiper.slides.forEach((slide, index) => {
        const columnIndex = Math.floor(index / rows);
        const rowIndex = index % rows;
  
        if (rowIndex === 1) { // 0 = first row, 1 = second row
          slide.classList.add("second-row");
        }
      });
    }
    const swiperInstance = new Swiper(swiperEl, {
      slidesPerView: 5,
      grid: {
        rows: 1,
        fill: "row",
      },
      loop: true,
      allowTouchMove: true,
      speed: 4000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },

      on: {
      init: function () {
        markSecondRowSlides(this);
      },
      resize: function () {
        markSecondRowSlides(this); 
      }
    },
      breakpoints: {
        0: {
          slidesPerView: 2,
          grid: {
            rows: 1,
            fill: "row",
          },
        },
        1024: {
          slidesPerView: 5,
          grid: {
            rows: 1,
            fill: "row",
          },
        },
      } 
    });
  });
});




/*追加*/
document.addEventListener("DOMContentLoaded", function() {
  const lazyVideos = document.querySelectorAll('video.lazy-video');

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const video = entry.target;
        const source = video.querySelector('source');
        
        // Move data-src → src
        if (source.dataset.src && !source.src) {
          source.src = source.dataset.src;
        }

        // Ensure muted before attempting play
        video.muted = true;
        video.load();

        // Attempt to play
        video.play().catch(err => {
          console.warn("Autoplay prevented, will retry on user interaction:", err);
          // Retry playback after the first user click/tap
          const retryPlay = () => {
            video.play();
            document.removeEventListener("click", retryPlay);
          };
          document.addEventListener("click", retryPlay);
        });

        // Stop observing once loaded
        observer.unobserve(video);
      }
    });
  }, { rootMargin: '200px' });

  lazyVideos.forEach(video => observer.observe(video));
});